<template>
    <v-card class="article-card rounded-lg clickable" @click="goToArticle(article)">
        <div class="article-card__media">
            <div class="media-blur-backdrop" :style="{ backgroundImage: `url('${getArticleImage()}')` }" />
            <v-img
                :src="getArticleImage()"
                contain
                aspect-ratio="1.7778"
                class="article-card__img"
            />
            <span v-if="article.date" class="article-card__date">{{ formatDate(article.date) }}</span>
        </div>
        <div class="article-card__accent custom-orange" />
        <v-card-title class="article-card-title">
            {{ article.title }}
        </v-card-title>
    </v-card>
</template>

<script>
    import momentTimezone from 'moment-timezone'

    export default {
        props: {
            article: {
                type: Object,
                default: null
            }
        },
        methods: {
            getArticleImage() {
                return `${'https://storage.googleapis.com'}/${this.article.image}`
            },
            formatDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY')
            },
            goToArticle(article) {
                this.$router.push({ name: 'Article', params: { id: article.id } })
            }
        }
    }
</script>

<style scoped>
.article-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.article-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.18) !important;
}

.article-card__media {
    position: relative;
    overflow: hidden;
    background: #111;
}

.article-card__img {
    transition: transform 0.4s ease;
}

.article-card:hover .article-card__img {
    transform: scale(1.05);
}

.article-card__date {
    position: absolute;
    z-index: 2;
    top: 10px;
    left: 10px;
    padding: 2px 10px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.65);
    color: white;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.05em;
}

.article-card__accent {
    height: 4px;
}

.article-card-title {
    text-align: left;
    word-break: break-word;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.35;
    padding: 12px 14px 16px;
    /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix -- the line clamp needs the prefixed box */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    overflow: hidden;
}

@media (max-width: 600px) {
    .article-card-title {
        font-size: 1rem;
    }
}
</style>
